import React from 'react';
import { Box } from '@components/Box';
import { registryPageData } from '@data-ts/pages/registry';
import { HorizontalSlider } from '@sections/shared/HorizontalSlider';
import { ShopRegistryDepartment } from '@sections/registry/ShopRegistrySection/ShopRegistryDepartment';
import { SECTION_ID, VENDOR_IMAGES, SLIDE_SPEED } from './ShopRegistrySection.constants';
import { Vendors, StyledBox, StyledSliderWrapper } from './ShopRegistrySection.styles';
import { InfiniteSlider } from '@components/InfiniteSlider';

const { shopRegistry } = registryPageData;

export const ShopRegistrySection: React.FC = () => {
  return (
    <Box as="section" id={SECTION_ID} paddingX={[7, 0]}>
      <Vendors paddingY={[7, 9]}>
        <StyledBox paddingBottom={[0, 3]}>
          <InfiniteSlider
            scrollName="registry-brands"
            stopOnHover
            images={VENDOR_IMAGES}
            speed={SLIDE_SPEED}
            gap={{ sm: 72, belowSm: 45 }}
            imageScale={{ belowSm: 1, sm: 0.8, lg: 0.8, xl: 1.2 }}
            scale={{ belowSm: 1, sm: 1, lg: 1, xl: 1 }}
            isEagerLoading={true}
          />
        </StyledBox>
      </Vendors>
      <StyledSliderWrapper>
        <HorizontalSlider
          title={shopRegistry.shopTitle}
          titlePadding={[0, 9]}
          items={[
            {
              id: 'DepartmentCurations',
              item: (
                <ShopRegistryDepartment
                  title="Collections"
                  image="registry-v2/ab-test/departments/curations-v2.jpg"
                  link="/shop/curations"
                />
              ),
            },
            {
              id: 'DepartmentKitchen',
              item: (
                <ShopRegistryDepartment title="Kitchen" image="registry-v2/ab-test/departments/kitchen.jpg" link="/shop/catalog/kitchen" />
              ),
            },
            {
              id: 'DepartmentTabletop',
              item: (
                <ShopRegistryDepartment
                  title="Tabletop"
                  image="registry-v2/ab-test/departments/tabletop-v2.jpg"
                  link="/shop/catalog/tabletop"
                />
              ),
            },
            {
              id: 'DepartmentBedBath',
              item: (
                <ShopRegistryDepartment
                  title="Bed & Bath"
                  image="registry-v2/ab-test/departments/bedbath.jpg"
                  link="/shop/catalog/bed-bath"
                />
              ),
            },
            {
              id: 'DepartmentHome',
              item: <ShopRegistryDepartment title="Home" image="registry-v2/ab-test/departments/home.jpg" link="/shop/catalog/home" />,
            },
            {
              id: 'DepartmentLifestyle',
              item: (
                <ShopRegistryDepartment
                  title="Travel & Leisure"
                  image="registry-v2/ab-test/departments/lifestyle.jpg"
                  link="/shop/catalog/lifestyle"
                />
              ),
            },
            {
              id: 'DepartmentCashFunds',
              item: (
                <ShopRegistryDepartment
                  title="Cash Funds"
                  image="registry-v2/ab-test/departments/cashfunds.jpg"
                  link="/shop/catalog/cash-funds"
                />
              ),
            },
            {
              id: 'DepartmentExperiences',
              item: (
                <ShopRegistryDepartment
                  title="Experiences"
                  image="registry-v2/ab-test/departments/experiences.jpg"
                  link="/shop/catalog/experiences"
                />
              ),
            },
          ]}
        />
      </StyledSliderWrapper>
    </Box>
  );
};
